var $cc8cbf248c4ac933$exports = {};
$cc8cbf248c4ac933$exports = {
  "alert": "\u062A\u0646\u0628\u064A\u0647",
  "dismiss": "\u062A\u062C\u0627\u0647\u0644"
};
export { $cc8cbf248c4ac933$exports as default };